import Loadable from 'my-components/Loadable';

export default Loadable(
  () => import(/* webpackChunkName: "sat-act-practice-test-results" */ './SATACTPracticeTestResultsPageCtnr'),
);
